/**
 * Takes the location url of the feed client and matches against mappings. Mappings has an id and list of urls mapping to that id.
 * @param {*} chatUrl location URL of chat client
 * @param {*} mappings id is the id of the chat room, urls are the list of urls mapping to that id.
 */
export const getChannelIdFromUrl = (chatUrl, mappings) => {
  const res = mappings.filter((mapping) =>
    mapping.urls.some((url) => chatUrl.startsWith(url))
  );
  if (!res) {
    return '';
  }
  return res;
};
